import SummaryChartPage from './SummaryChartPage';
export { SummaryChartPage };
export default SummaryChartPage;
